const butlerSchool = {
  // HeroSection
  'butlerSchool.hero.homeLink': 'ホーム',
  'butlerSchool.hero.currentPage': '執事学校とは？',
  'butlerSchool.hero.title': '執事学校とは？',
  'butlerSchool.hero.titleEn': 'WHAT IS A BUTLER SCHOOL',
  'butlerSchool.hero.lead': '「執事学校」は、執事の技能を教える教育機関を指す一般名詞です。英国の邸宅で受け継がれてきた技能が、なぜ学校という形で教えられるようになったのか——その成り立ちと世界の潮流、そして日本での位置づけを整理します。',
  'butlerSchool.hero.imgAlt': '書斎の机で記録帳に万年筆で書き込む年配の男性執事',

  // Definition
  'butlerSchool.definition.label': 'DEFINITION',
  'butlerSchool.definition.mainLine': '特定の一校の名前ではなく、執事を教える場のカテゴリ名。',
  'butlerSchool.definition.sub1': '固有名詞ではなく、教育機関のカテゴリ名',
  'butlerSchool.definition.para1': '執事学校とは、執事の技能を体系立てて教える教育機関の総称です。特定の一校を指す固有名詞ではなく、「調理を教える学校」「語学を教える学校」と同じ水準のカテゴリ名として使われます。呼び名も一定ではなく、執事養成学校、バトラースクールといった言い方が地域や時代によって混在してきました。いずれも指している中身は同じで、執事として働くための知識と所作を、教える側が課程として設計して伝える場のことです。',
  'butlerSchool.definition.sub2': '資格制度の名称でもない',
  'butlerSchool.definition.para2': 'この言葉は、資格制度の名前でもありません。日本には執事の国家資格という制度自体が存在せず、何をもって修了とするかは、教育を行う機関や認定を担う団体がそれぞれ定めています。したがって修了したという事実だけでは、身につけた範囲までは分かりません。どの課程を、どのような評価を経て修めたのか——執事養成学校を比べるときに見るべきなのは、学校という言葉そのものではなく、その中身のほうです。',
  'butlerSchool.definition.sub3': '「教える場」と「手配する事業」は機能が別',
  'butlerSchool.definition.para3': '混同されやすいのが、執事を教える機関と、執事の仕事を依頼したい方へ人材を手配する事業との違いです。前者は人を育て、課程の修了を認定します。後者は依頼の内容に応じて、働き手と依頼先を結びつけます。担う機能が異なるため、同じ「執事」という言葉が付いていても役割は重なりません。日本の執事学校について調べるときは、まずこの二つを分けて見ると、情報が整理しやすくなります。',
  'butlerSchool.definition.img1Alt': 'クリスタルのシャンデリアと紫のドレープが設えられた洋風の応接室で、黒モーニングコートに白手袋の若い男性執事が黒いフォルダーを両手に持ち正面を向いて微笑む全身ポートレート',
  'butlerSchool.definition.img2Alt': '金彩の皿と、リボンで結ばれた巻物の証書を真上から見た様子',
  'butlerSchool.definition.img3Alt': '応接室で教本を手に受講生二名へ講義する講師',
  'butlerSchool.definition.example': '「執事学校はどこがいいですか」という問いは、「大学はどこがいいですか」と同じ構造をしています。答えは、何を学びたいのか——所作の基礎なのか、家政の管理なのか、危機対応なのか——によって変わります。カテゴリ名で選ぶのではなく、課程の中身で選ぶ。それがこの言葉との、正しい付き合い方です。',

  // History
  'butlerSchool.history.label': 'HISTORY',
  'butlerSchool.history.title': '学校という形が生まれるまで',
  'butlerSchool.history.subtitleEn': 'How Butler Schools Came to Be',
  'butlerSchool.history.lead': '執事は、はじめから学校で学ぶ職業ではありませんでした。教える場が必要になるまでには、三つの段階があります。',
  'butlerSchool.history.era1.num': '01',
  'butlerSchool.history.era1.title': '邸宅のなかで受け継がれた時代',
  'butlerSchool.history.era1.desc': '英国のカントリーハウス、すなわち地方の大邸宅では、執事は家政を束ねる役職として置かれていました。技能を伝えたのは学校ではなく、邸宅そのものです。若い使用人は下位の役職から入り、先任者の手つきを見て覚え、任される範囲を少しずつ広げながら執事へ上がっていきました。\n\n銀器の扱いも、灯りの支度も、客人の迎え方も、その家のやり方として口伝と模倣で受け継がれます。ヴィクトリア時代（1837〜1901年）は、産業革命で富を得た上流階級が多くの壮麗な邸宅を築いた執事文化の黄金期であり、大邸宅では使用人の組織が大きく育ち、役職ごとの分担と序列がはっきりしていました。家内使用人のトップに立つ役職が家令（スチュワード）で、人事・経理をはじめ、主人の手紙の代筆や旅行の手配までを担いましたが、この役職が置かれたのは非常に大きな邸宅にかぎられていました。\n\n執事はその下で、来客対応や馬車での外出付き添い、食卓の給仕にあたるフットマンを監督し、酒類や銀器の管理と食卓の給仕を受け持ちます。家令が置かれていない邸宅では、執事が人事・経理も担当して使用人のトップを務めました。女性使用人はハウスキーパーが室内を束ね、リネンや陶磁器の管理、日用品の購入・支給を担いながら、掃除を受け持つハウスメイドを統括します。\n\n家族の食事をつくるコックは、キッチンメイドを補助につけて食材の調達までを受け持ち、洗い物はスカラリーメイドが担いました。女性主人に仕えるレディーズメイドは、ドレスの着替えの補助やヘアセットなど身の回りの世話にあたります。主人の身の回りに付く従者（ヴァレット）は衣服の管理や身支度の補助、旅行の荷造りを担い、靴磨きや汚れ仕事、使い走りといった雑務は少年が就くことの多い下級の使用人であるホールボーイが受け持つなど、役職ごとに領域が明確に分かれていました。',
  'butlerSchool.history.era1.imgAlt': '燭台に火を灯す執事の手元',
  'butlerSchool.history.era2.num': '02',
  'butlerSchool.history.era2.title': '教える場が必要になった時代',
  'butlerSchool.history.era2.desc': '二十世紀に入ると、二度の大戦と社会構造の変化により、大邸宅を維持することが難しくなります。住み込みで働く使用人は大きく減り、邸宅のなかで先任者から後任者へ受け継ぐという仕組み自体が細っていきました。一方で、行き届いた家政を求める需要が消えたわけではありません。受け継ぐ場を失った技能を、どこかで教え直す必要が生まれます。ここではじめて、邸宅の外に教える場を置くという発想が、現実の課題として立ち上がりました。',
  'butlerSchool.history.era2.imgAlt': '白手袋の講師が皿の脇にフォークを置き、着席した受講生がテーブルセッティングの手順を見て学ぶ様子',
  'butlerSchool.history.era3.num': '03',
  'butlerSchool.history.era3.title': '課程として体系化された時代',
  'butlerSchool.history.era3.desc': '二十世紀後半以降、執事の技能を課程として組み直す動きが各地で進みました。見て覚えるものだった所作を科目に分け、学ぶ順序を決め、修了の判定基準を置く——教育としての骨格が与えられたのです。期間・科目・評価が定まったことで、学びの範囲を外から確かめられるようになりました。今日、執事学校あるいは執事養成学校と呼ばれる教育機関は、この体系化の延長線上にあります。',
  'butlerSchool.history.era3.imgAlt': 'グラスの曇りを光にかざして確かめる女性執事',
  'butlerSchool.history.note': '※ここで述べているのは、英国の邸宅文化と執事教育に共通する一般的な経緯です。特定の教育機関の沿革を指すものではありません。',

  // Global direction
  'butlerSchool.global.label': 'GLOBAL TRENDS',
  'butlerSchool.global.title': '世界の執事教育が向かう方向',
  'butlerSchool.global.subtitleEn': 'Where Butler Education Is Heading',
  'butlerSchool.global.lead': '成り立ちを踏まえると、いま各国の執事教育が何を重く見ているかが見えてきます。共通しているのは、邸宅という前提から離れ、働く現場の広がりに合わせて中身を組み替えている点です。',
  'butlerSchool.global.1.title': '学びの現場が邸宅の外へ広がる',
  'butlerSchool.global.1.desc': '想定される職場は、個人の邸宅だけではなくなりました。ホテルの上級客室階、サービス付きのレジデンス、法人の来賓対応——人が滞在し、もてなしを必要とする場所すべてが現場になっています。教える側も、邸宅を前提とした所作だけでなく、施設として運用される場での立ち居振る舞いを扱うようになりました。',
  'butlerSchool.global.2.title': '所作に加えて、運営と管理を扱う',
  'butlerSchool.global.2.desc': '磨く・整える・供するといった所作は、土台であり続けます。そのうえで近年重みを増しているのが、備品や在庫の管理、支出の把握、人と時間の段取りといった運営の領域です。ひとりの手わざとしてではなく、場を回す仕事として執事を捉える視点が加わっています。',
  'butlerSchool.global.3.title': '文化差を前提とした応対',
  'butlerSchool.global.3.desc': '出身も信仰も食習慣も異なる方をお迎えすることが当たり前になり、ひとつの型をそのまま当てはめる応対は成り立たなくなりました。相手の背景を確かめ、必要なら形を変える——判断をともなう応対が、課程のなかで扱われるようになっています。',
  'butlerSchool.global.4.title': '守秘を職業倫理として明示する',
  'butlerSchool.global.4.desc': '執事は、依頼主の私生活にきわめて近い距離で働きます。だからこそ、知り得たことを口にしないという原則を、個人の心得ではなく職業倫理として課程に明示する流れが強まっています。技能と同じ重さで倫理を教えることが、いまの執事教育の共通項です。',
  'butlerSchool.global.imgAlt': 'ホテルのロビーで茶器を載せた盆を運ぶ執事とスタッフ',
  'butlerSchool.global.caption': 'かつて邸宅の内側にあった仕事は、いま滞在の場そのものへ広がっている。',

  // Japan position
  'butlerSchool.japan.label': 'IN JAPAN',
  'butlerSchool.japan.title': '日本での位置づけと、私たちの現在地',
  'butlerSchool.japan.subtitleEn': 'Butler Education in Japan',
  'butlerSchool.japan.lead': '英国で邸宅から学校へと移ってきた流れを、日本はそのまま辿ってはいません。前提が違うからです。',
  'butlerSchool.japan.h3.1': '受け継ぐ土台がないところから始まっている',
  'butlerSchool.japan.para1': '日本において執事は、邸宅文化のなかで自然に受け継がれてきた職業ではありません。だからこそ、教える場が担う役割は英国以上に大きくなります。手つきを見せてくれる先任者が身近にいない以上、知識も所作も、教育として意識的に組み立てるほかないからです。日本の執事学校が担っているのは、失われた伝統の復元ではなく、この国の現場に合う形での組み立て直しだと私たちは考えています。',
  'butlerSchool.japan.h3.2': '日本における学び舎の現在地',
  'butlerSchool.japan.para2': '日本国内で、受講生が実際に足を運んで学べる場を構える例は多くありません。日本執事アカデミーは、東京・お台場に本校を構え、日本で唯一の学び舎を持つ執事養成学校です。固有校としての課程や定員、修了の扱いといった詳細は「日本執事アカデミーとは」のページに譲り、ここではカテゴリとしての位置づけ——邸宅文化の継承がない日本で、教える場がどのように立っているか——に焦点を当てます。',
  'butlerSchool.japan.h3.3': 'カテゴリとしての言葉と、固有の一校',
  'butlerSchool.japan.para3': 'ここまで述べてきた執事学校という語は、あくまで教育機関のカテゴリを指す言葉です。そのカテゴリのなかで、日本執事アカデミーは英国由来の型と日本のおもてなしを接続することを自らの役割としています。世界の潮流と同じく、邸宅を前提としない現場——ホテル、レジデンス、法人の接遇——を視野に入れながら課程を組んでいます。当校の理念や学びの中身については、関連ページからご覧ください。',
  'butlerSchool.japan.imgAlt': '東京湾を望むテラスに立つ執事',
  'butlerSchool.japan.fact1': '邸宅文化の継承がない前提から開始',
  'butlerSchool.japan.fact2': '教える場が担う役割が大きい',
  'butlerSchool.japan.fact3': '東京・お台場に本校を構える、日本で唯一の学び舎を持つ執事養成学校',
  'butlerSchool.japan.fact4': '現場に合わせた組み立て直し',
  'butlerSchool.japan.fact5': '詳細は「日本執事アカデミーとは」のページへ',

  // FAQ
  'butlerSchool.faq.label': 'FAQ',
  'butlerSchool.faq.title': 'よくあるご質問',
  'butlerSchool.faq.subtitleEn': 'Frequently Asked Questions',
  'butlerSchool.faq.footer': 'その他のご質問はお問い合わせフォームよりお寄せください',
  'butlerSchool.faq.q1': '「執事学校」と「執事養成学校」は違うものですか？',
  'butlerSchool.faq.a1': 'どちらも同じものを指します。執事の技能を教える教育機関に対する一般的な呼び名であり、制度上の区別はありません。バトラースクールという言い方も、同じ意味で使われています。',
  'butlerSchool.faq.q2': '執事学校はいつごろからあるのですか？',
  'butlerSchool.faq.a2': '教育機関としての形が整ったのは二十世紀後半以降です。それ以前、英国では執事の技能は邸宅のなかで先任者から受け継がれており、外部で教える場は必要とされていませんでした。邸宅の縮小によって受け継ぐ仕組みが細り、課程として体系化する動きが生まれました。',
  'butlerSchool.faq.q3': '海外と日本では、学ぶ内容が違いますか？',
  'butlerSchool.faq.a3': '土台となる考え方——観察して先回りすること、所作を型として身につけること、守秘を守り抜くこと——は共通です。違いが出るのは想定する現場で、日本ではホテルやレジデンス、法人の接遇が占める比重が高くなります。もっとも近年は海外でも現場が邸宅の外へ広がっており、扱う内容は近づきつつあります。',
  'butlerSchool.faq.q4': '執事学校を修了すると国家資格が得られますか？',
  'butlerSchool.faq.a4': '日本に執事の国家資格という制度はありません。修了の認定は、教育を行う機関や認定団体がそれぞれの基準で行います。どの課程を、どのような評価で修めたのかは学校ごとに異なるため、言葉だけでなく中身を確認する必要があります。日本執事アカデミーでの扱いは、当校のページにてご確認ください。',
  'butlerSchool.faq.q5': '執事を手配する事業と同じものですか？',
  'butlerSchool.faq.a5': '別のものです。教育機関は人を育て、課程の修了を認定します。手配する事業は、依頼の内容に応じて働き手と依頼先を結びつけます。日本執事アカデミーは執事養成学校として、教育を担う側の機関です。',

  // CTA
  'butlerSchool.cta.label': 'TAKE THE NEXT STEP',
  'butlerSchool.cta.title': '学びの中身をご覧ください',
  'butlerSchool.cta.body': 'カテゴリとしての説明の次は、実際の課程です。コースの構成や学びの進め方について、ご不明な点はお気軽にお問い合わせください。',
  'butlerSchool.cta.note': '※ご相談はオンラインでも承ります',
  'butlerSchool.cta.courses': 'コースを見る',
  'butlerSchool.cta.consultation': '個別相談を予約する',

  // Related pages
  'butlerSchool.related.title': '関連ページ',
  'butlerSchool.related.subtitleEn': 'Explore Further',
  'butlerSchool.related.viewLink': '詳しく見る',
  'butlerSchool.related.backLink': 'アカデミーについての総合ページへ戻る',
  'butlerSchool.related.link0.title': 'アカデミーについて',
  'butlerSchool.related.link0.desc': '運営体制と学び方の全体像',
  'butlerSchool.related.link1.title': '全日本執事協会について',
  'butlerSchool.related.link1.desc': '運営母体と提供する事業のご紹介',
  'butlerSchool.related.link2.title': '教育理念・方針',
  'butlerSchool.related.link2.desc': '私たちが大切にする教育の考え方',
  'butlerSchool.related.link3.title': 'コース一覧・比較',
  'butlerSchool.related.link3.desc': '3つのコースの違いを一覧で確認',
  'butlerSchool.related.link4.title': 'カリキュラム概要',
  'butlerSchool.related.link4.desc': '学びの全体像と進め方',
  'butlerSchool.related.link5.title': '修了証・認定資格について',
  'butlerSchool.related.link5.desc': '修了で得られる協会認定資格',

  // Last updated
  'butlerSchool.lastUpdated': '最終更新: 2026年7月25日',
};

export default butlerSchool;
